import { Cartographer } from "../cartographer.js"
import { MapControl, MapControlProps } from "./mapControl.js"
import { GeomapService } from "../geomapService.js"
import { FAIcon, FAIconProps } from "../../core/components/faIcon.js";
import React from "react";
import ReactDOM from "react-dom";

export class Map extends React.Component<MapProps, any>{
    private _geomapService: GeomapService;
    private _map: google.maps.Map;
    private _cartographer: Cartographer;
    private readonly _mapGuid: string;
    private _trafficLayer: google.maps.TrafficLayer;
    private _controlDiv: HTMLElement;

    constructor(props: MapProps) {
        super(props);
        this._mapGuid = kendo.guid();
        this._geomapService = new GeomapService();
    }

    private _addEventListerners = () => {
        if (typeof this.props.clickHandler === "function") {
            this._map.addListener("click", this._onClick);
        }
        if (typeof this.props.rightClickHandler === "function") {
            this._map.addListener("rightclick", this._onRightClick);
        }
    }

    private _draw = (lat: number, lng: number) => {
        if (this._map == null) {
            //if ((lat == null || lng == null) && navigator && navigator.geolocation) {
            //    navigator.geolocation.getCurrentPosition((pos) => {
            //        const coords = pos.coords;
            //        lat = coords.latitude;
            //        lng = coords.longitude;
            //        this._createMap(lat, lng);
            //    }, () => {
            //        this._createMap(lat, lng);
            //    });
            //}
            //else {
            //    this._createMap(lat, lng);
            //}
            this._createMap(lat, lng);
        }
    }

    private _createMap = (lat: number, lng: number) => {
        this._map = new google.maps.Map(document.getElementById(this._mapGuid), {
            center: { lat: (lat || 51.48981815), lng: (lng || 7.40336400359168) },
            zoom: 4
        });
        if (this.props.enableTrafficInformation) {
            // @ts-ignore
            let controlUIStyle = {
                backgroundColor: '#fff',
                border: '2px solid #fff',
                borderRadius: '3px',
                boxShadow: '0 2px 6px rgba(0,0,0,.3)',
                cursor: 'pointer',
                marginLeft: '20px',
                marginTop: '11px',
                textAlign: 'center'
            } as React.CSSProperties;

            this._controlDiv = document.createElement('div');
            ReactDOM.render(
                React.createElement(MapControl, { clickHandler: this.toggleTrafficLayer, uiStyle: controlUIStyle, title: this.props.translations["GeoMap.ShowTraffic"] } as MapControlProps,
                React.createElement(FAIcon, { name: "road", sameWidth: true, attributes: ["2x"] } as FAIconProps)), this._controlDiv);
            this._map.controls[google.maps.ControlPosition.TOP_LEFT].push(this._controlDiv);
        }
        this._cartographer = new Cartographer(this._map);
        this._cartographer.pinConfig = this.props.pinConfig;
        this._addEventListerners();
        this.props.mapCreated(lat, lng, this._cartographer, this._mapGuid);
    }

    private _onClick = (e: google.maps.MouseEvent) => {
        this.props.clickHandler(e);
    }

    private _onRightClick = (e: google.maps.MouseEvent) => {
        this.props.rightClickHandler(e);
    }

    initializeMap = () => {
        this._draw(this.props.lat, this.props.lng);
    }

    toggleTrafficLayer = (e: any) => {
        if (this._trafficLayer) {
            e.currentTarget.style.backgroundColor = "rgb(255, 255, 255)";
            this._trafficLayer.setMap(null);
            this._trafficLayer = null;
        }
        else {
            e.currentTarget.style.backgroundColor = "rgb(235, 235, 235)";
            this._trafficLayer = new google.maps.TrafficLayer();
            this._trafficLayer.setMap(this._map);
        }
    }

    componentDidMount() {
        this._geomapService.initializeGoogleMaps(this.initializeMap);
    }

    componentWillUnmount() {
        if (this._controlDiv) {
            ReactDOM.unmountComponentAtNode(this._controlDiv);
        }
    }

    render() {
        return <div className="geomap__map" id={this._mapGuid}></div>;
    }
}

// @ts-ignore
export interface MapProps extends React.PropsWithChildren {
    lat?: number;
    lng?: number;
    clickHandler?(e: google.maps.MouseEvent): void;
    rightClickHandler?(e: google.maps.MouseEvent): void;
    mapCreated(lat: number, lng: number, cartographer: Cartographer, mapGuid: string): void;
    translations?: any;
    enableTrafficInformation: boolean;
    pinConfig?: any;
}